import 'magnific-popup'

export default {
    delovni_cas() {

        let delovni_cas = $('.form_delovni_cas')
        if(delovni_cas.length) {
            delovni_cas.find('input[type="checkbox"]').on('change', function() {
                let $this = $(this)
                let $parent = $this.closest('.form_delovni_cas-day')

                if($this.is(':checked')) {
                    // Zaprt dan: urni polji onemogočeni (onemogočena polja so izvzeta iz required preverjanja)
                    $parent.find('input.tr-input-time').prop('disabled', true).val('')
                    $parent.addClass('disabled')
                } else {
                    $parent.find('input.tr-input-time').prop('disabled', false)
                    $parent.removeClass('disabled')
                }
            })

            // Začetno stanje: pri shranjenih zaprtih dneh uskladi onemogočenost polj
            delovni_cas.find('input[type="checkbox"]:checked').trigger('change')
        }
    },



    nacin_sprejemanja_rezervacij() {
        let nacin_rezervacij = $('input[type="radio"][name="nacin_rezervacij"]')

        function toggleNavodilaFor($radio) {
            let $navodilaAll = $('.navodila-image')
            if (!$navodilaAll.length || !$radio || !$radio.length) return

            let target = $radio.data('navodilaImage') || $radio.val()
            // Hide all and show only matching
            $navodilaAll.addClass('hidden')
            let $show = $navodilaAll.filter('[data-navodila-image="' + target + '"]')
            if ($show.length) {
                $show.removeClass('hidden')
            }
        }

        // Prikaže polja izbranega načina: A → interval terminov (samo prikaz, ni obvezen), B → ročni termini.
        // Seating dolžina je vedno vidna (nad izbiro A/B), shrani pa se samo pri načinu B.
        function toggleNacinPolja(val) {
            $('.a_nacin_rezervacij_polja').toggleClass('hidden', val !== 'a')
            $('.b_nacin_rezervacij_polja').toggleClass('hidden', val !== 'b')
        }

        nacin_rezervacij.on('change', function () {
            let $this = $(this)
            toggleNacinPolja($this.val())

            // Toggle navodila-image based on selected option
            toggleNavodilaFor($this)
        })

        // Initialize fields + navodila-image visibility from current selection
        let $selected = $('input[type="radio"][name="nacin_rezervacij"]:checked')
        if ($selected.length) {
            toggleNacinPolja($selected.val())
            toggleNavodilaFor($selected)
        }



        /**
         * B način sprejemanja rezervacij
         */ 

        let b_nacin_rezervacij_polja = $('.b_nacin_rezervacij_polja')

        if (b_nacin_rezervacij_polja.length) {
            b_nacin_rezervacij_polja.find('input[type="checkbox"]').on('change', function () {
                let $this = $(this)
                let $rezervacijePolja = $this.closest('.b_nacin_rezervacij_polja-day')
                let $terminiPolja = $rezervacijePolja.find('.b_nacin_rezervacij_polja-termini')
                let $terminiDodaj = $rezervacijePolja.find('.b_nacin_rezervacij_polja-dodaj-termin')

                if ($this.is(':checked')) {
                    $rezervacijePolja.addClass('disabled')

                    // remove all termin rows from $terminiPolja except the first one
                    $terminiPolja.find('.b_nacin_rezervacij_polja-termin-row').not(':first').remove()

                    $terminiPolja.find('input.tr-input-time').prop('disabled', true).val('')
                    $terminiDodaj.prop('disabled', true)

                } else {
                    $rezervacijePolja.removeClass('disabled')
                    $terminiPolja.find('input.tr-input-time').prop('disabled', false)
                    $terminiDodaj.prop('disabled', false)
                }

                dodaj_remove_gumb($rezervacijePolja)
            })


            // DODAJANJE TERMINOV
            let b_nacin_rezervacij_polja_dodaj_termin = $('.b_nacin_rezervacij_polja-dodaj-termin')
            b_nacin_rezervacij_polja_dodaj_termin.on('click', function () {

                let $this = $(this)
                let dayWrapper = $this.closest('.b_nacin_rezervacij_polja-day')
                let $terminiPolja = $this.closest('.b_nacin_rezervacij_polja-day').find('.b_nacin_rezervacij_polja-termini')
                let day = $this.closest('.b_nacin_rezervacij_polja-day').data('day')
                let dayIndex = $this.closest('.b_nacin_rezervacij_polja-day').data('day-index')


                // Find the last input and get its data-input-index, then increment by 1
                let lastInput = $terminiPolja.find('input.tr-input-time').last();
                let lastIndex = parseInt(lastInput.attr('data-input-index')) || 0;
                let newIndex = lastIndex + 1;
                $terminiPolja.append(`
                    <div class="b_nacin_rezervacij_polja-termin-row flex flex-wrap gap-x-2 gap-y-1 items-center" data-required-anchor>
                        <input type="text" class="tr-input-time" name="sprejemanje_rezervacij_${day}_${dayIndex}_${newIndex}" data-input-index="${newIndex}">
                        <div class="b_nacin_rezervacij_polja-termin-do flex items-center gap-x-1 whitespace-nowrap">do: <span class="b_nacin_rezervacij_polja-termin-do-val tr-input-time tr-input-time--static" aria-live="polite"></span></div>
                        <div class="b_nacin_rezervacij_polja-remove-termin button button-grayout hover:bg-yellow! hover:border-yellow! font-normal! px-2! py-1! text-[10px]">- Odstrani termin</div>
                    </div>
                `);

                dodaj_remove_gumb(dayWrapper)
            })



            // Odstranjenvanje TERMINOV
            $(document).on('click', '.b_nacin_rezervacij_polja-remove-termin', function () {

                let $this = $(this)
                let dayWrapper = $this.closest('.b_nacin_rezervacij_polja-day')

                // Remove the row this button belongs to (allows removing any termin, not just the last)
                $this.closest('.b_nacin_rezervacij_polja-termin-row').remove()

                dodaj_remove_gumb(dayWrapper)
            })



            function dodaj_remove_gumb(parentElement) {
                // show per-row remove gumbi only when there is more than one termin
                let $rows = parentElement.find('.b_nacin_rezervacij_polja-termin-row')
                $rows.find('.b_nacin_rezervacij_polja-remove-termin').toggleClass('hidden', $rows.length <= 1)
            }


        }
    },




    // Ob vsakem terminu načina B prikaže konec rezervacije: termin + seating_dolzina (min). Samo prikaz, nič se ne shranjuje.
    terminiDoSeating() {
        const form = document.getElementById('tr-delovni-cas-form')
        const seatingInput = document.getElementById('seating_dolzina')
        if (!form || !seatingInput) return

        const pad = n => String(n).padStart(2, '0')

        function terminPlusSeating(termin, seatingMin) {
            const m = /^(\d{1,2}):(\d{2})$/.exec((termin || '').trim())
            if (!m || !(seatingMin > 0)) return ''
            const total = (parseInt(m[1], 10) * 60 + parseInt(m[2], 10) + seatingMin) % (24 * 60)
            return pad(Math.floor(total / 60)) + ':' + pad(total % 60)
        }

        function toMinutes(termin) {
            const m = /^(\d{1,2}):(\d{2})$/.exec((termin || '').trim())
            return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null
        }

        // Opomba pod vrstico termina (isti element uporablja required-fields.js ob oddaji, ker je vrstica [data-required-anchor])
        function setRowError(row, input, msg) {
            let note = row.querySelector(':scope > .tr-required-error')
            if (msg) {
                if (!note) {
                    note = document.createElement('div')
                    note.className = 'tr-required-error text-red text-[12px] basis-full'
                    row.appendChild(note)
                }
                note.textContent = msg
                note.classList.remove('hidden')
                row.dataset.requiredMessage = msg
                input.setCustomValidity(msg)
                input.classList.add('field-required-error')
            } else {
                input.setCustomValidity('')
                delete row.dataset.requiredMessage
                if (note) note.classList.add('hidden')
                if (input.validity.valid) input.classList.remove('field-required-error')
            }
        }

        function refresh() {
            const seatingMin = parseInt(seatingInput.value, 10) || 0
            form.querySelectorAll('.b_nacin_rezervacij_polja-day').forEach(day => {
                let prevEnd = null // konec prejšnjega termina v minutah, brez prehoda čez polnoč (za primerjavo)
                day.querySelectorAll('.b_nacin_rezervacij_polja-termin-row').forEach(row => {
                    const input = row.querySelector('input.tr-input-time')
                    const box = row.querySelector('.b_nacin_rezervacij_polja-termin-do')
                    if (!input || !box) return

                    // Okvirček je vedno viden; brez termina ali seatinga ostane prazen
                    box.querySelector('.b_nacin_rezervacij_polja-termin-do-val').textContent = input.disabled ? '' : terminPlusSeating(input.value, seatingMin)

                    // Termin se ne sme začeti pred koncem prejšnjega (prejšnji termin + seating)
                    const startMin = input.disabled ? null : toMinutes(input.value)
                    let msg = ''
                    if (startMin !== null && seatingMin > 0 && prevEnd !== null && startMin < prevEnd) {
                        msg = 'Termin se lahko začne šele ob ' + pad(Math.floor(prevEnd / 60) % 24) + ':' + pad(prevEnd % 60) + ', ko se konča prejšnji termin.'
                    }
                    setRowError(row, input, msg)
                    if (startMin !== null && seatingMin > 0) prevEnd = startMin + seatingMin
                })
            })
        }

        // Termin (flatpickr sproži input/change), seating, kljukice "zaprto" (praznijo termine) in gumbi za dodajanje/odstranjevanje
        form.addEventListener('input', refresh)
        form.addEventListener('change', refresh)
        form.addEventListener('click', e => {
            if (e.target.closest && e.target.closest('.b_nacin_rezervacij_polja-dodaj-termin, .b_nacin_rezervacij_polja-remove-termin')) {
                setTimeout(refresh, 0)
            }
        })
        refresh()
    },



    // Minimalni čas za odpoved je viden samo, ko je no-show strošek večji od 0 (prazno ali 0 = brez no-showa).
    noShowOdpoved() {
        let $noShow = $('#no_show_strosek')
        let $odpoved = $('.no_show_odpoved_polje')
        if (!$noShow.length || !$odpoved.length) return

        function toggle() {
            let val = parseFloat($noShow.val())
            $odpoved.toggleClass('hidden', !(val > 0))
        }

        $noShow.on('input change', toggle)
        toggle()
    },



    tip_rezervacijskega_sistema() {
        let tip_rezervacijskega_sistema = $('input[type="radio"][name="tip_rezervacijskega_sistema"]')

        tip_rezervacijskega_sistema.on('change', function () {
            let $this = $(this)
            if ($this.val() === 'svoj_rezervacijski_sistem') {
                $('.tip_rezervacijskega_sistema_svoj').removeClass('hidden')
            } else {
                $('.tip_rezervacijskega_sistema_svoj').addClass('hidden')
            }
        })

        // Initialize state on load (so required/hidden matches saved selection)
        const $selected = $('input[type="radio"][name="tip_rezervacijskega_sistema"]:checked')
        if ($selected.length) {
            $selected.trigger('change')
        }
    },




	// Lightbox (Magnific) za slike navodil: .navodila-image (preklop načina A/B) in .tr-floorplan-example
	// (primer načrta prostora, dashboard-tr-delovni-cas.php). Vsak vsebovalnik odpre samo svojo sliko.
	navodlilaImageMagnificPopup() {

		let navodilaImage = $(".navodila-image, .tr-floorplan-example")
		
        if (navodilaImage.length) {
            
            // console.log(navodilaImage)

			navodilaImage.magnificPopup({
				delegate: "a",
				type: "image",
				closeOnContentClick: false,
				closeBtnInside: false,
				mainClass: "mfp-with-zoom mfp-img-mobile",
				image: {
					verticalFit: true,
                    titleSrc: function (item) {

						if (item.el.data("description") && item.el.attr("title")) {
							// console.log(item.el.attr("title"))
							// console.log(item.el.data("description"))
							return (
								item.el.attr("title") + " | " + item.el.data("description")
							)
						} else if (item.el.attr("title")) {
							return item.el.attr("title")
						} else if (item.el.data("description")) {
							return item.el.data("description")
						}
					},
				},
				gallery: {
					enabled: false,
				},
				zoom: {
					enabled: true,
					duration: 300, // don't foget to change the duration also in CSS
					opener: function (element) {
						const $img = element.is('img') ? element : element.find('img')
						return $img.length ? $img : element
					},
				},
			})
		}

    },
    

    // If a day is marked as closed in .form_delovni_cas, disable and clear the corresponding
    // reservation time inputs in .b_nacin_rezervacij_polja for the same day (matched by data-day-index)
    zaprtiDneviChecking() {
        function applyDayState(dayIndex, isClosed) {
            let $day = $('.b_nacin_rezervacij_polja-day[data-day-index="' + dayIndex + '"]')
            if (!$day.length) return

            let $termini = $day.find('.b_nacin_rezervacij_polja-termini')
            let $addBtn = $day.find('.b_nacin_rezervacij_polja-dodaj-termin')
            let $zaprtoCb = $day.find('input[type="checkbox"][name$="_zaprto"]')

            if (isClosed) {
                // keep only first termin row
                $termini.find('.b_nacin_rezervacij_polja-termin-row').not(':first').remove()
                // disable and clear times, disable add button
                $termini.find('input.tr-input-time').prop('disabled', true).val('')
                $addBtn.prop('disabled', true)
                // mirror closed state to B-mode "zaprto" checkbox: check it, apply change logic, then disable
                if ($zaprtoCb.length) {
                    $zaprtoCb.prop('checked', true).trigger('change').prop('disabled', true)
                }
                // hide remove buttons (only one row remains)
                $day.find('.b_nacin_rezervacij_polja-remove-termin').addClass('hidden')
                // disable all interactive fields inside day
                $day.find('input, select, textarea, button').prop('disabled', true)
                $day.addClass('disabled')
            } else {
                // re-enable all controls; the internal "zaprto" checkbox will re-apply its own logic on change
                $day.find('input, select, textarea, button').prop('disabled', false)
                if ($zaprtoCb.length) {
                    $zaprtoCb.prop('disabled', false).prop('checked', false).trigger('change')
                }
                $day.removeClass('disabled')
            }
        }

        // Bind change handler on closed-day checkboxes
        $(document).on('change', '.form_delovni_cas-day input[type="checkbox"]', function () {
            let $this = $(this)
            let dayIndex = $this.closest('.form_delovni_cas-day').data('day-index')
            applyDayState(dayIndex, $this.is(':checked'))
        })

        // Initialize current state for all days
        $('.form_delovni_cas-day').each(function() {
            let $daySrc = $(this)
            let dayIndex = $daySrc.data('day-index')
            let isClosed = $daySrc.find('input[type="checkbox"]').is(':checked')
            applyDayState(dayIndex, isClosed)
        })
    } 



    
}